import { orderConfirmationBillingInformationStyles } from "@insite/content-library/Widgets/OrderConfirmation/OrderConfirmationBillingInformation";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { css } from "styled-components";

Object.assign(orderConfirmationBillingInformationStyles, {
    ...orderConfirmationBillingInformationStyles,
    billingAddressTitle: {
        css: css`
            display: none;
        `,
    },
    billingInformationTitle: {
        variant: "h3",
        css: css`
            @media print {
                font-size: 15px;
            }
            padding-top: 0;
            margin-bottom: 0;
            padding-bottom: 2px;
        `,
    },
});
